var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',{attrs:{"card-body-classes":"table-full-width","no-footer-line":""}},[_c('div',{staticClass:"col-12"},[_c('h4',[_vm._v("Sub Topic")]),_c('p',[_vm._v(_vm._s(_vm.subTopic.description))]),_c('div',{staticClass:"row"},[_c('router-view')],1)])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }